import {OfferStatusStatus} from "@pg-rp/common-types/src/types/OfferStatusStatus";

const COMPASS_OFFER_STATUSES = [OfferStatusStatus.STATUS_STATUS_IN_PREPARATION, OfferStatusStatus.STATUS_STATUS_TO_ACQUIRE];

// Status is optional - listing scenarios (e.g. offer-detail-map, property-configurator-list) do not return it
export const isCompassOffer = (offer: {status?: {status: OfferStatusStatus}}) => {
    const status = offer.status?.status;

    return status !== undefined && COMPASS_OFFER_STATUSES.includes(status);
};
import {OfferStatusStatus} from "@pg-rp/common-types/src/types/OfferStatusStatus";

const COMPASS_OFFER_STATUSES = [OfferStatusStatus.STATUS_STATUS_IN_PREPARATION, OfferStatusStatus.STATUS_STATUS_TO_ACQUIRE];

// Status is optional - listing scenarios (e.g. offer-detail-map, property-configurator-list) do not return it
export const isCompassOffer = (offer: {status?: {status: OfferStatusStatus}}) => {
    const status = offer.status?.status;

    return status !== undefined && COMPASS_OFFER_STATUSES.includes(status);
};
